var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C13.2782 11 15.125 9.15317 15.125 6.875C15.125 4.59683 13.2782 2.75 11 2.75C8.72183 2.75 6.875 4.59683 6.875 6.875C6.875 9.15317 8.72183 11 11 11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.125 0 0 6.83237 0 6.83237C0 6.83237 4.125 13.75 11 13.75C17.875 13.75 22 6.875 22 6.875C22 6.875 17.875 0 11 0ZM11 12.375C4.98438 12.375 1.71875 6.875 1.71875 6.875C1.71875 6.875 4.98438 1.375 11 1.375C17.0156 1.375 20.2812 6.875 20.2812 6.875C20.2812 6.875 17.0156 12.375 11 12.375Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/view.da83db74cc54f9d8c9c63642e2e3387a.svg";